import React from "react";
import BusTicketScreen from "../../../common/AllTickets/Bus/BusTicketScreen";
function SuperBusTicket() {
  return <BusTicketScreen mode="ADMIN" />;
}

export default SuperBusTicket;
